module.exports = __webpack_public_path__ + "img/banner-principal.da3eff3b.svg";